var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesignationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.6 14.65L10 12.8L12.4 14.65L11.5 11.6L13.75 10H10.95L10 6.9L9.05 10H6.25L8.5 11.6L7.6 14.65ZM3.825 20L6.15 12.4L0 8H7.6L10 0L12.4 8H20L13.85 12.4L16.175 20L10 15.3L3.825 20Z",
    fill: "#F6764E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesignationIcon);
export default __webpack_public_path__ + "static/media/designationIcon.c9f642e35579364868c4f038f15f13da.svg";
export { ForwardRef as ReactComponent };